module.exports = __webpack_public_path__ + "img/Daniel_Starczynowski.159173a9.png";